<template>
    <div id="relatorio-facturacao">
        
        <vs-row vs-type="flex" vs-justify="flex-start" class="mb-10" vs-w="12">
            <vs-col vs-type="flex" style="width:auto;align-items: center;" >
                <span class="mr-2">Data Início</span>
                <datepicker 
                    placeholder="Selecionar Data"
                    :highlighted="highlighted"
                    v-model="startDate"
                    @closed="closeTimePicker"
                    :language="ptBR"
                    style="z-index: 401;">
                </datepicker>
            </vs-col>
            
            <vs-col vs-type="flex" style="width:auto;align-items: center;">
                <span class="mr-2">Data Fim</span>
                <datepicker 
                    placeholder="Selecionar Data"
                    :highlighted="highlighted"
                    v-model="endDate"                    
                    :disabledDates="getDisabledDates"
                    @closed="closeTimePicker"
                    :language="ptBR"
                    style="z-index: 401;">
                </datepicker>
            </vs-col>

            
            <vs-col vs-type="flex" style="width:auto;align-items: center;">
                <vs-button color="primary" type="filled" @click="applyDates">Aplicar</vs-button>
            </vs-col>
        </vs-row>

        <vs-row vs-type="flex" vs-justify="space-between" class="mb-10" vs-w="12">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-lg="12"  vs-xs="12">
                <vs-table pagination search
                          max-items="50"        
                          noDataText="Não foram encontrados registos"
                          :data="data_billing"
                          v-model="billing_table" style="width: 100%;"> 
                    <template slot="header">
                        <h3 class="mb-5">Facturação</h3>
                    </template>

                    <template slot="thead">
                        <vs-th> Hotel </vs-th>
                        <vs-th> Artigo </vs-th>
                        <vs-th> Artigo ID </vs-th>
                        <vs-th> Evento </vs-th>
                        <vs-th> Valor </vs-th>
                        <vs-th> Valor NET </vs-th>
                        <vs-th> Nº Reserva </vs-th>
                        <vs-th> Documento </vs-th>
                        <vs-th> Colaborador </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, indextr) in data" :key="indextr" :state="indextr % 2 == 0 ?'primary':null">

                            <vs-td>{{ tr.hotel }}</vs-td>
                            <vs-td>{{ tr.artigo }}</vs-td>
                            <vs-td>{{ tr.item_id }}</vs-td>
                            <vs-td>{{ tr.evento }}</vs-td>
                            <vs-td>{{ tr.vb }}</vs-td>
                            <vs-td>{{ tr.vn }}</vs-td>
                            <vs-td>{{ tr.reserva }}</vs-td>
                            <vs-td>{{ tr.documento }}</vs-td>
                            <vs-td>{{ tr.colaborador }}</vs-td>

                        </vs-tr>
                    </template>
                </vs-table>
            </vs-col>
        </vs-row>
        
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {ptBR} from 'vuejs-datepicker/dist/locale';
    import axios from 'axios';                
    import 'flatpickr/dist/flatpickr.css';   
    import themeConfig from '@/../themeConfig.js';

    export default {
        name: 'Facturacao',
        props: [
        'hotelSelected',
        ],
        data: function() {
            return {
                    data_billing: [],
                    startDate: new Date(),
                    endDate: new Date(),
                    billing_table: null,                            
                    highlighted: {
                        dates: [
                            new Date(Date.now())
                        ]
                    },
                    ptBR: ptBR,
            }
        }, 
        components: {
            Datepicker
        },
        methods: {
            closeTimePicker(){},

            async loadBillingData() {
                try {

                    let dates = [
                        this.formatDate(this.startDate),
                        this.formatDate(this.endDate)
                    ]
                    
                    this.$vs.loading();
                    let token = window.localStorage.getItem('usertoken')
                    let response = await axios.post( themeConfig.apiurl + '/spa/reports/billing', {  
                        token: token,
                        hotel_id: this.hotelSelected,
                        dates: dates
                    })
                    
                    
                    this.data_billing = response.data.data

                } catch (error) {
                    this.notify(error.response.data.message, 'red');
                    this.data_billing = []
                    this.$vs.loading.close();
                } finally {
                    this.$vs.loading.close();
                }
            },

            formatDate(date) {
                let d = new Date(date)
                let month = '' + (d.getMonth() + 1)
                let day = '' + d.getDate()
                let year = d.getFullYear()

                return [day.padStart(2, '0'), month.padStart(2, '0'), year].join('-')
            },

            applyDates(){
                this.loadBillingData()
            }

        }, 
        mounted: function() {} ,   
        created() {}, 
        computed: {
            getDisabledDates() {
                if (!this.startDate) {
                    return {}
                }

                let start = new Date(this.startDate)
                let disableTo = new Date(start.getFullYear(), start.getMonth(), start.getDate());

                return { to: disableTo }
            }

        },
        watch: {  
            hotelSelected: {
                immediate: true,
                handler(newVal) {
                    if (newVal) {
                        this.loadBillingData()
                    }
                }
            }

        },
    }
</script>
